export default {
  // navbar: {
  //   dashboard: "Dashboard",
  //   github: "Github",
  //   logOut: "Log Out",
  //   profile: "Profile",
  //   theme: "Theme",
  //   size: "Global Size"
  // },
  login: {
    logIn: "Login",
    phone: "Phone",
    password: "Password",
    keepPwd: "Remember the Password",
    reg: "New User Registration",
    lostPwd: "Forgot Password"
  },
  reg: {
    title: "Register",
    username: "Name",
    age: "Age",
    phone: "phone",
    comName: "Co. Name",
    comAddr: "Co. Add.",
    position: "Position",
    experYears: "Work Years",
    email: "Email",
    authCode: "CAPTCHA",
    getCode: "Get Code",
    agree:'You have read and agree to the ',
    explain: "User Agreement・User Privacy"
  },
  forgetPwd: {
    title: "Lost Password",
    pwd: "Please set your password",
    newPwd: "Please set a new password",
    confirm: "Confirm"
  },
  footer: {
    wapTips:'Mobile phone users please scan the QR code below to access the official account',
    wapLink: 'After sales technical website WeChat official account',
    friendlyLink: 'Links',
    link2Des:'For remote maintenance links, please click below',
    link1: 'ARKRAY HomePage',
    link2: 'Remote Maintenance',
    new: 'News and Notice',
    comName: 'Aikelai International Trading (Shanghai) Co. Ltd',
    phone: 'Contact Us：',
    addr: 'Address：ARKRAY Marketing Shanghai,Inc Room1002,T.1 Buildings,1388 Kaixuan road，Changning District Shanghai ,CHINA 〒200052 ',
    privacyPolicy: "Privacy Policy",
    UseClauses: "Use Clauses",
    feedBack:"Feedback",
  },
  navbar: {
    personalData: "Personal Data",
    myMessage: "My Message",
    trainingTest: "Training test",
    testCenter: "Test Center",
    favorites: "Facorites",
    browserHistory: "Cookies",
    logOut: "Log Out",
    feedBack:"Feedback",
    certificate: 'Certificate'
  },
  more: "More",
  iconMenu: {
    academic: "Academic Related",
    fault: "Fault Manual",
    maintain: "New Information Release",
    tool: "Tool Use",
    exam: "Training • Assessment",
    datum: "Club Information",
    upload: 'Data Download',
    trainingMaterials: 'Training examination study materials',
    academicTest: 'Academic test',
    primaryTest: 'The primary test',
    juniorTest: 'Junior Test',
    intermediateTest: 'Intermediate test',
    advancedTest: 'Advanced test',
  },
  searchContent: "Please enter your search",
  searchHistory: 'Search Histories',
  searching: 'You are searching',
  documentClass: 'Document Class',
  InstrumentClass: 'Instrument Class',
  faultClass:'Fault Manual Class',
  my: {
    baseInfo: "Basic Info",
    accountInfo: "Account Information",
    amend: "Edit",
    inputName: "Please enter your name",
    inputAge: "Please enter your age",
    inputComName: "Please enter your company name",
    inputComAddr: "Please enter your company address",
    inputPosition: "Please enter your position",
    inputWorkYears: "Please enter your years of experience",
    inputEmail: "Please enter your email address",
    account: "ID",
    checkPwd: "（Please verify the original password first）",
    min: "（The minimum length is 6 characters）",
    pwd: "Old Password",
    newPwd: "New Password",
    confirmPwd: "Confirm Password",
    cancle: "Cancel",
    confirm: "Confirm",
    changePwd: "Change Password",
    sign: "Mark as Read",
    noMessage: "No message~",
    seeMore: 'See More',
    publishTime: 'Start Time',
    deadline: 'Deadline',
    lifespan: 'Lifespan',
    testLogging: 'Test Logging',
    noTestLogging: 'No record~',
    viewingHours: 'Viewing Hours',
    TestRecords: 'Test Records',
    points: 'Points',
    examDates: 'Exam Dates',
    goBack: 'Go Back',
    download: 'Download',
    startExam: 'The Exam Will Begin',
    testTime: 'The Test Of Time',
    noFurtherRecords: "No Further Records Are Available",
    startTest: 'To Begin Testing',
    through: 'Through',
    unqualified: 'Unqualified',
    delSelect:'Batch Delete',
    readSelect:'Batch Read',
    selectAll:'Select All',
    selectThisPage:'Select Page All',
    haveSelect:'Selected',
    //
    feedBackList:'Feedback List',
    toFeedBack:'Add feedback',
    sendTime:'Submission Time',
    ToBeReplied:'To Be Replied',
    haveReplied:'Replied',
    feedBacker:'Feedback Person',
    feedBackerCount:'Feedback Account',
    feedBackContent:'Feedback Content',
    feedBackDetailsPls:'Please Fill In The Feedback',
    feedBackPic:'Picture',
    sendfeedBack:'Submit',
    feedBackDetails:'Reply Details',
    search:'Search',
    sendContent:'Please Enter The Content',
    sendBack:'Reply',
  },
  noData: 'No data~',
  home: 'Home',
  viewTestResults: 'View Test Results',
  returnHome: 'Return To The Home Page',
  countdown: 'The Countdown',
  answer: 'Answer',
  completeSubmission: 'Complete Submission',
  testResults: 'The test results',
  Tools: 'Tool',
  advert: {
    Advertising: "Advertising",
    TopInstructions: 'Your trust is very important to us, we know the importance of user information security, we will in accordance with the requirements of laws and regulations, take security measures to protect your user information security and control. As such, are formulated (or "we") the legal notices and privacy policy "(or" statement and policy "for short) and remind you: before using the service, please be sure to read carefully and thoroughly understand the" legal notices and privacy policy ", the confirmation of fully understands and agrees that the use of related products and services. Once you start using it, it will be deemed as acceptance and acceptance of the contents of this Statement and Policy',
    AccountRegistrationUse: '1、Account registration and use',
    TheTermsOfOneFirst: '1.1 You may need to register an account to use the network services provided by Aikelai. After you register successfully, you have the right to log in using the email address, mobile phone number, blog account name and password set by you.',
    TheTermsOfOneSecond: '1.2 The account name and password set by you during registration will be the only valid identification for Aikelai to identify you. It is specially reminded that the account name and password are set by you and you are responsible for keeping. You are legally responsible for all activities and events that occur after you log in with your name and password.',
    TheTermsOfOneThird: '1.3 You should not transfer or lend your account or password to others. If you find that your account has been illegally used by others, you should immediately notify acolai. Akelai will not be liable for any illegal use of your account or password due to hacking or negligence of your custody.',
    TheTermsOfOneFourth: '1.4 As the provider of Aikelai network services, Aikelai can require you to complete real name authentication in accordance with Chinese laws and regulations in order to make you better use of ikelai network services and ensure the security of your account.',
    TheTermsOfOneFifth: '1.5 You must provide true, accurate, complete, legal and valid information to Aikelai when you register and use Aikelai web services, and you are obligated to maintain and update your information in a timely manner. If the information provided by you violates the requirements of this article, you shall be liable for the consequences caused thereby, and ecolor reserves the right to terminate your use of ecolor’s network services.',
    TheTermsOfOneSixth: '1.6 If you are a minor under the age of 18, you should complete registration and use the legal services provided by Aikelai with the participation of your parent or legal guardian.',
    AccountRegistrationUseTwo: '2、Account registration and use',
  },
  startPreview: 'Start Preview',
  describe: 'Describe',
  regInstruct: {
    RegistrationForNewUsers: 'Registration instructions for new users',

  },
  useClause: {
    useTerms: 'Terms of use',

  },
  inputAnswer: 'Please enter your answer',
  lazyFetch: 'Seconds after getting',
  getSMS: 'Get SMS',
  examMsgStart: 'The exam will begin',
  examMsgTesting: 'To begin testing',
  message: 'Tip: you can get the best experience with Google browser',
  scoreTip:'In the grade',
  agreeTip:"Agree to the above",
  lastArtical:'Last article',
  nextArtical:'Next Article',

};
